import CompanyRoutes from '@company/routes/CompanyRoutes';
import { ChatProvider } from '@company/state/chatContext';
import { CompanyProvider } from '@company/state/companyContext';
import { DirectMessageProvider } from '@company/state/directMessageContext';

export default function CompanyAppShell() {
  return (
    <CompanyProvider>
      <ChatProvider>
        <DirectMessageProvider>
          <CompanyRoutes />
        </DirectMessageProvider>
      </ChatProvider>
    </CompanyProvider>
  );
}
